import classnames from "classnames";
import { withPrefix } from "gatsby";
import _ from "lodash";
import React from "react";
import { SocialIcon } from "react-social-icons";
import { getAppMediaPreview, getAppMediaSrc, mediaTypes } from "../../utils/media";
import * as styles from "./index.module.scss";

export default ({
  title,
  appStyles = {},
  T,
  desktopExtraTitle,
  kioskTitle,
  forDesktop,
  className,
}) => {
  const {
    HomeFirstTitle,
    HomeMobileFirstTitle,
    HomeSecondTitle,
    HomeExtraTitlesDesktop,
    HomeMainTitleDesktop,
    HomeThirdTitle,
    DesktopTitleLogo,
    hompageTitleCentered: center,
    desktopTitleLogoJustifyContent
  } = appStyles;

  const logoImage = _.get(DesktopTitleLogo, "backgroundImage");
  const { backgroundImage, ...logoImageProps } = DesktopTitleLogo || {};
  const appMediaLogoSrc = getAppMediaSrc(mediaTypes.desktopTitleLogo, appStyles);
  const appMediaLogoPreview = getAppMediaPreview(mediaTypes.desktopTitleLogo, appStyles);
  const logoBackground = appMediaLogoSrc
    ? `url(${appMediaLogoSrc})`
    : appMediaLogoPreview
    ? `url(${appMediaLogoPreview})`
    : logoImage && `url(${withPrefix(logoImage)})`;

  return (
    <div>
      {!forDesktop && <div
        className={classnames(
          className,
          styles.HomeTitle,
          center && styles.Center,
          styles.HideOnDesktop,
        )}
      >
        <span
          style={{
            ...(HomeMobileFirstTitle || HomeFirstTitle),
            marginLeft: 10,
          }}
        >
          {title}
        </span>
        <span style={HomeSecondTitle}>{T("{{business_name_title}}")}</span>
        <span style={HomeThirdTitle}>
          {T("{{business_name_second_title}}")}
        </span>
      </div>}
      <div
        className={classnames(
          styles.HomeTitleDesktop,
          center && styles.Center,
          styles.HideOnMobile,
        )}
      >
        {DesktopTitleLogo && (
          <div style={{ display: "flex", justifyContent: desktopTitleLogoJustifyContent || "center" }}>
            <div
              style={{
                ...logoImageProps,
                backgroundImage: logoBackground,
                backgroundRepeat: "no-repeat",
                backgroundPositionX: "center",
                ... _.get(logoImageProps, "height") ? {height: `${_.replace(_.get(logoImageProps, "height"), "px","")}px`} : {},
                ... _.get(logoImageProps, "width") ? {width: `${_.replace(_.get(logoImageProps, "width"), "px","")}px`} : {},
              }}
            />
          </div>
        )}
        {kioskTitle ? (
          <div
            className={styles.TitlePadding}
            style={{
              display: "flex",
              flexDirection: "column",
              textAlign: "center",
            }}
          >
            <span style={{ ...HomeSecondTitle, marginBottom: 60 }}>
              {T("{{business_name_desktop}}")}
            </span>
            <span style={HomeMainTitleDesktop}>{kioskTitle}</span>
          </div>
        ) : appStyles.desktopTitleOnSeparateLine ? (
          <div className={classnames(styles.HomeTitleDesktop)}>
            <span style={HomeFirstTitle}>{T("{{desktop_title_prefix}}")}</span>
            <span style={HomeMainTitleDesktop}>
              {T("{{business_name_desktop}}")}
            </span>
            <span style={HomeThirdTitle}>{T("{{desktop_title_suffix}}")}</span>
          </div>
        ) : (
          <span
            style={HomeMainTitleDesktop}
            className={styles.TitlePadding}
          >{`${T("{{desktop_title_prefix}}")} ${T(
            "{{business_name_desktop}}",
          )}${
            _.startsWith(T("{{desktop_title_suffix}}"), "'")
              ? T("{{desktop_title_suffix}}")
              : ` ${T("{{desktop_title_suffix}}")}`
          }`}</span>
        )}
        <span
          style={{
            color: appStyles.accentColor,
            paddingLeft: 16,
            paddingRight: 16,
            ...HomeExtraTitlesDesktop,
          }}
        >
          {desktopExtraTitle}
        </span>
        {appStyles.socialLinks && (
          <div
            style={{
              paddingLeft: appStyles.alignSocialLinksToLeft ? 8 : 0,
              display: "flex",
              justifyContent: appStyles.alignSocialLinksToLeft
                ? "flex-start"
                : "center",
            }}
          >
            {_.map(
              _.filter(_.values(appStyles.socialLinks), _.negate(_.isEmpty)),
              (url, indx) => (
                <SocialIcon
                  key={url + indx}
                  target="_blank"
                  url={url}
                  style={{ margin: 4, ...appStyles.SocialLink, ..._.get(appStyles.SocialLink, "textColor")? {fill: _.get(appStyles.SocialLink, "textColor")}:{}}}
                  fgColor={_.get(appStyles.SocialLink, "textColor") || "#fff"}
                  bgColor={appStyles.actionColor}
                />
              ),
            )}
          </div>
        )}
      </div>
    </div>
  );
};
